import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './GroupPage';
import { AppState } from '../../../../types/store';
import { getThisGroup } from '../../../../selectors/page';
import {
  dropFirstTimeFlagSimple,
  FirstTimeFlag,
  hasFirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { getIsBurgerMenuOpen } from '@wix/da-shared-react/pkg/SiteHeader/redux/selectors';

export type StateProps = Pick<Props, 'group' | 'showFTUE' | 'isNetworkbarOpen'>;
export type DispatchProps = Pick<Props, 'dropFirstTimeFlag'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  group: getThisGroup(state),
  showFTUE: hasFirstTimeFlag(
    state,
    FirstTimeFlag.IsNetworkbarGroupWatchNotUsed
  ),
  isNetworkbarOpen: getIsBurgerMenuOpen(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  dropFirstTimeFlag: dropFirstTimeFlagSimple,
};

export default connect(mapStateToProps, mapDispatchToProps);
